import { IRatingDetails } from 'shared/repositories/dailyrent/entities/response/RatingDetails';

import type { IState } from '../../store';

/**
 * Селектор для получения детальной информации о рейтинге (для полного виджета)
 */
export const selectRatingDetails = (state: IState): IRatingDetails | null => {
  return state.dailyrentData?.ratingDetails || null;
};
